<template>
  <el-container direction="vertical">
    <el-row style="margin-top: 10px;margin-right: 20px;">
      <el-col style="text-align:right;">
        <el-button type="warning" size='mini' @click="submitError">提交异常照片</el-button>
        <el-button type="primary" size='mini' @click="submitExactly">确认无误照片</el-button>
      </el-col>
    </el-row>
    <!-- 数据展示 -->
    <div style="flex: 1; margin: 10px; display: flex;border:1px solid #ccc;padding: 10px; background:rgb(239, 239, 239);">
      
      <div style="flex: 1; overflow: auto; height: 100% flex-wrap:wrap;border: 1px solid #ccc;background:#fff;">
        <div v-for="(item,index) in photoList" :key="index" class="imageItem" >
          <img style="width: 108px; height: 144px" :class="{'img-selected':selectedList.indexOf(item.id) != -1}" :src="`http://39.96.211.161:8085/api/works/photo/view?id=`+item.id" @click="chooseImage(item)">
        </div>
      </div>
      <div style="width: 121px; height: 100%; background: #fff;border: 1px solid #ccc;margin-left: 10px;overflow:auto">
        <div v-for="(item,index) in selectedList" :key="index" class="imageItem" style="display:inline;">
            <img style="width: 108px; height: 144px" draggable="false" :src="`http://39.96.211.161:8085/api/works/photo/view?id=`+item" @click="cancelChoose(item)">
          </div>
      </div>
    </div>
  </el-container>  
</template>

<script>
export default {
  computed: {
    hasRole() {
      let manager = this.globalData.manager
      let roles = this.globalData.exportRole
      return roles.includes(manager.id)
    },
    isBj(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    }
  },
  data() {
    return {
      fit: 'cover',
      search:'',
      photoList: [],
      selectedList: [],
    }
  },
  methods: {


    // 分页显示数据
    pageChange(n) {
      this.loadData(n)
    },

    // 数据查询
    query() {
      this.search.pageNum = 1
      this.api.works.findAwardList(this.search).then(res => {
        this.page = res.data
      })
    },

    isBjRole(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    },

    // 加载数据
    loadData(n) {
      this.api.works.findAwardPhotoList().then(res => {
        this.photoList = res.data
      })    
    },
    chooseImage(item){
      console.log(item)
      this.selectedList.push(item.id)
      this.f = '1'
    },
    cancelChoose(id){
      let index = this.selectedList.indexOf(id)
      this.selectedList.splice(index,1)
    },
    submitError(){
      this.$confirm('是否提交这些异常照片?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = this.photoList.map(item => {
            return item.id
          })
          this.api.works.changePhotoStatus({ids: this.selectedList,status: 2}).then(() => {
            this.selectedList = [];
            this.loadData()
          })

        }).catch(() => {});
    },
    submitExactly(){
      
      this.$confirm('是否确认这些照片无误并要提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = this.photoList.map(item => {
            return item.id
          })
          this.api.works.changePhotoStatus({ids: ids,status: 1}).then(() => {
            this.selectedList = [];
            this.loadData()
          })

        }).catch(() => {});
    }
  },
  mounted() {
    this.loadData(1)
  }
}
</script>

<style>
.imageItem{
  float: left;
  margin:7px;
  width: 108px;
  height: 144px;
  border-radius: 4px;
}

.img-selected{
  box-shadow: 0 0 1px 5px #9a4f72
}
</style>


